/* Gabarit d'article SEO Talika (template article.seo) — v2, octobre 2026 */
(function () {
  var root = document.querySelector('.tk-article');
  if (!root) return;
  var content = root.querySelector('.tk-article__content');
  if (!content) return;
  function slug(s) {
    return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
  }
  /* Ancres sur les H2, puis sommaire (colonne latérale sur ordinateur, repliable sur mobile) */
  var used = {};
  var h2s = Array.prototype.filter.call(content.querySelectorAll('h2'), function (h) { return !h.closest('.tk-sources'); });
  h2s.forEach(function (h) {
    if (h.id) return;
    var id = slug(h.textContent) || 'section', base = id, n = 2;
    while (used[id] || document.getElementById(id)) { id = base + '-' + n; n += 1; }
    used[id] = true; h.id = id;
  });
  var toc = root.querySelector('#tk-toc');
  if (toc && h2s.length >= 3) {
    var list = toc.querySelector('.tk-toc__list'), links = [];
    var mq = window.matchMedia('(min-width: 1100px)');
    h2s.forEach(function (h) {
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#' + h.id; a.textContent = h.textContent;
      a.addEventListener('click', function () { if (!mq.matches) toc.open = false; });
      li.appendChild(a); list.appendChild(li); links.push(a);
    });
    toc.hidden = false;
    var sync = function () { toc.open = mq.matches; };
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
    if ('IntersectionObserver' in window) {
      var current = null;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) current = e.target; });
        if (!current) return;
        links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + current.id); });
      }, { rootMargin: '-15% 0px -70% 0px', threshold: 0 });
      h2s.forEach(function (h) { io.observe(h); });
    }
  }
  /* Première carte produit : au repère data-tk-produit, sinon elle reste en fin d'article */
  var box = root.querySelector('.tk-products');
  var cards = box ? box.querySelectorAll('.tk-product') : [];
  if (cards.length) {
    var first = cards[0];
    var marker = content.querySelector('[data-tk-produit="' + first.getAttribute('data-handle') + '"]') || content.querySelector('[data-tk-produit]');
    if (marker && marker.parentNode) {
      marker.parentNode.insertBefore(first, marker);
      marker.parentNode.removeChild(marker);
      if (!box.querySelector('.tk-product')) box.parentNode.removeChild(box);
    }
  }
  Array.prototype.forEach.call(content.querySelectorAll('[data-tk-produit]'), function (m) { m.parentNode.removeChild(m); });
  /* FAQ : données structurées FAQPage */
  var faq = content.querySelector('.tk-faq');
  if (faq) {
    var items = [];
    Array.prototype.forEach.call(faq.querySelectorAll('details'), function (d) {
      var q = d.querySelector('summary'), a = d.querySelector('p');
      if (q && a) items.push({ '@type': 'Question', name: q.textContent.trim(), acceptedAnswer: { '@type': 'Answer', text: a.textContent.trim() } });
    });
    if (items.length) {
      var s = document.createElement('script'); s.type = 'application/ld+json';
      s.text = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: items });
      document.head.appendChild(s);
    }
  }
})();
